<template>
  <el-container style="height: 100vh; width: 100vw">
    <el-header class="navbar">
      <Navbar></Navbar>
    </el-header>
    <el-container class="main">
      <el-aside class="menu">
        <el-scrollbar><Menu></Menu></el-scrollbar>
      </el-aside>
      <el-container class="content">
        <el-header class="tag-header">
          <TagView></TagView>
        </el-header>
        <el-main class="content2">
        <el-scrollbar>
          <router-view v-slot="{Component}">
            <keep-alive :include="visitedViews">
              <component :is="Component"/>
            </keep-alive>
          </router-view>
        </el-scrollbar>
        </el-main>
      </el-container>
    </el-container>
  </el-container>
</template>

<script>
import Menu from '@/components/menu/Menu.vue'
import Navbar from "@/components/Navbar";
import TagView from "@/components/TagView";
import {useRouterStore} from "@/store/router";
import {computed} from "vue";

export default {
  name: 'layout',
  components: {
    Navbar,
    Menu,
    TagView,
  },
  setup() {
    const routerStore = useRouterStore()
    const visitedViews = computed(() => {
      return routerStore.visitedViews.map(item => item.name)
    })
    return { visitedViews }
  }
}
</script>

<style lang="scss" scoped>

.menu {
  width: 180px;
  margin-top: 15px;
}

.navbar {
  height: 60px;
  padding: 0;
}

.tag-header {
  padding: 0;
  height: 41px;
}

.content {
  border-left: 1px solid #eee;
  padding: 0;
}

.content2 {
  padding: 0;
}

.main {
  height: calc(100vh - 60px);
}

</style>